module.exports = __webpack_public_path__ + "static/img/非标自动化组装线.258c1f2d.png";